export class PageViews {
  static HomePageView = "home";
  static UserPageView = "user";
  static CompanyPageView = "company";
  static BeneficiaryPageView = "beneficiary";
  static CampaignPageView = "campaigns";
  static BenefitPageView = "benefit";
  static SalesHistoriesPageView = "sales-histories";
  static FinancialStatementPageView = "financial-statement";
  static NetworkFinancialStatementsPageView = "network-financial-statements";
  static NetworkFinancialStatementsPaymentPageView = "network-financial-statement-payment";
  static FinancialReportPageView = "financial-report";
  static NetworkTermPageView = "network-term";
  static LpmManagementPageView = "lpm-management";
  static ProductManagementPageView = "product-management";
  static TransactionalManagement = "transactional-management";
  static PractitionerManagement = "practitioner-management";
  static ClustersManagementPageView = "cluster-management";
  static DrugstoreTests = "drugstore-tests";
  static GeneralReport = "general-report";
  static AuditSale = "audit-sale";
  static AuditSaleDetails = "audit-sale-details";
  static TransactionLog = "transaction-log";
  static DeliveryPanel = "delivery-panel";
}
